import { userService } from "./user-service";
const AUTH_TOKEN = "AUTH_TOKEN";
const REFRESH_TOKEN = "REFRESH_TOKEN";
const OTP_EMAIL = "OTP_EMAIL";
// Helper function to map API user to our User interface
const mapApiUserToUser = (apiUser) => {
    return {
        id: apiUser.id,
        name: `${apiUser.firstName} ${apiUser.lastName}`.trim(),
        email: apiUser.email,
        userName: apiUser.userName,
        firstName: apiUser.firstName,
        lastName: apiUser.lastName,
        tenantId: apiUser.tenantId,
        roles: apiUser.roles,
        permissions: apiUser.permissions,
    };
};
const setAccessToken = (token) => {
    localStorage.setItem(AUTH_TOKEN, token);
};
const setRefreshToken = (token) => {
    localStorage.setItem(REFRESH_TOKEN, token);
};
const getAccessToken = () => {
    return localStorage.getItem(AUTH_TOKEN);
};
const getRefreshToken = () => {
    return localStorage.getItem(REFRESH_TOKEN);
};
const removeAccessToken = () => {
    localStorage.removeItem(AUTH_TOKEN);
};
const removeRefreshToken = () => {
    localStorage.removeItem(REFRESH_TOKEN);
};
const removeOtpEmail = () => {
    localStorage.removeItem(OTP_EMAIL);
};
const setOtpEmail = (email) => {
    localStorage.setItem(OTP_EMAIL, email);
};
const getOtpEmail = () => {
    return localStorage.getItem(OTP_EMAIL) || "";
};
// Selected Access Point caching
const SELECTED_AP_KEY = "SELECTED_ACCESS_POINT";
const setSelectedAccessPoint = (ap) => {
    localStorage.setItem(SELECTED_AP_KEY, JSON.stringify(ap));
};
const getSelectedAccessPoint = () => {
    const stored = localStorage.getItem(SELECTED_AP_KEY);
    if (stored) {
        try {
            return JSON.parse(stored);
        }
        catch (_a) {
            return null;
        }
    }
    return null;
};
const removeSelectedAccessPoint = () => {
    localStorage.removeItem(SELECTED_AP_KEY);
};
const localStorageAccessor = {
    setAccessToken,
    setRefreshToken,
    getAccessToken,
    getRefreshToken,
    removeAccessToken,
    removeRefreshToken,
    removeOtpEmail,
    setOtpEmail,
    getOtpEmail,
    // Access Point caching
    setSelectedAccessPoint,
    getSelectedAccessPoint,
    removeSelectedAccessPoint,
    // User methods
    setUser: (user) => userService.setUser(user),
    setApiUser: (apiUser) => userService.setUser(mapApiUserToUser(apiUser)),
    getUser: () => userService.getUser(),
    removeUser: () => userService.removeUser(),
    getUserDisplayName: () => userService.getUserDisplayName(),
    getUserEmail: () => userService.getUserEmail(),
    getUserInitials: () => userService.getUserInitials(),
    // Helper to check if user has valid token
    isAuthenticated: () => !!getAccessToken() && !!userService.getUser(),
};
export default localStorageAccessor;
